import { jsx as _jsx } from "react/jsx-runtime";
import 'ziphy-web-shared/basic/utils/toJSpolyfill/toJSpolyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { setInitConfig } from 'ziphy-web-shared';
import Initializer from '@src/Initializer';
import { InitializerConfig } from '@src/Initializer.config';
setInitConfig(InitializerConfig);
ReactDOM.render(_jsx(React.StrictMode, { children: _jsx(Initializer, {}) }), document.getElementById('root'));
